/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_No_CardInputs */

const en_plan_no_card = /** @type {(inputs: Plan_No_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No card on file. Add one to keep your subscription active.`)
};

const es_plan_no_card = /** @type {(inputs: Plan_No_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay tarjeta registrada. Agrega una para mantener tu suscripción activa.`)
};

/**
* | output |
* | --- |
* | "No card on file. Add one to keep your subscription active." |
*
* @param {Plan_No_CardInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_no_card = /** @type {((inputs?: Plan_No_CardInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_No_CardInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_no_card(inputs)
	return en_plan_no_card(inputs)
});